module.exports = __webpack_public_path__ + "assets/media/notification.bddc43e9.mp3";